import Upload from './Upload';
export { default as UploadPhotos } from './UploadPhotos';

export default Upload;
